import { ARCHIVED_BOOLEAN_FILTERS } from '@/common/api/archivedTableFilters';

export const ROLE_FILTER_KEYS = [...ARCHIVED_BOOLEAN_FILTERS] as const;

export type RoleFilterKey = (typeof ROLE_FILTER_KEYS)[number];
